<template>
  <div id="PrePaClub">
    <!-- PRE PA CLUB CARD -->
    <v-card outlined>
       <v-layout row align-center justify-center class="grey lighten-4 pb-2 mx-0"> 
        <span class="title font-weight-regular  align-center mt-1">Message Board</span>
      </v-layout>
      <v-container  pb-1>
          <v-layout  class="coupon-box">
              <input  class="promoCodeInput"  placeholder="Write message" type="text">
              <v-btn  small class="coupon-box__button">Post</v-btn>
          </v-layout>
       
        <!-- <v-list >
          <template v-for="(item, index) in items">
            <v-subheader
              v-if="item.header"
              :key="item.header"
              v-text="item.header"
            ></v-subheader>

            <v-divider
              v-else-if="item.divider"
              :key="index"
              :inset="item.inset"
            ></v-divider>

            <v-list-item
              v-else
              :key="item.title"
              @click=""
            >
              <v-list-item-avatar color="indigo">
                 <span class="white--text headline" v-html="item.name"></span>
              </v-list-item-avatar>

              
                <v-row>
                  <v-col>
                    <span class="font-weight-bold" v-html="item.title"> </span>
                    <span  class="caption grey--text"> {{item.date}}</span>
                  </v-col>
                   
                </v-row>
                
                <v-row>
                  <v-icon>mdi-thumb-up</v-icon>
                </v-row>
                
              
              
             
            </v-list-item>
          </template>
        </v-list> -->
       
      </v-container>
      <div id="container">
        <div class="postContainer">
          <div ><v-avatar color="indigo" class="white--text">C</v-avatar></div>
         <div class="items">
           <span class="font-weight-medium">Carolina</span> 
           <span class="caption grey--text">1 month ago</span>
           <p>Where is this school located? Is it far from North Carolina and then there are these 2 other options</p>
            <div class="iconsContainer">
              <div class="likesContainer">
               <v-icon >mdi-thumb-up</v-icon>
               <span class="grey--text caption ml-1">123</span>
              </div>

              <v-btn small outlined class="ml-5" @click="startReply = !startReply">REPLY</v-btn>

              <v-spacer></v-spacer>
              <v-btn small outlined @click="viewReplies = !viewReplies">View 2 Replies</v-btn>
           </div>
        
           <!-- Reply to Comment Section -->
           <div v-if="startReply" class="replyContainer">
             <v-card flat>
               <v-text-field label="type your reply"></v-text-field>
               <v-card-actions>
                 <v-spacer></v-spacer>
                 <v-btn @click="startReply = false">Cancel</v-btn>
                 <v-btn>Post Reply</v-btn>
               </v-card-actions>
             </v-card>
           </div>

           <div v-if="viewReplies" class="viewRepliesContainer">
               <div class="postContainer">
          <div ><v-avatar color="indigo" class="white--text">C</v-avatar></div>
         <div class="items">
           <span class="font-weight-medium">Carolina</span> 
           <span class="caption grey--text">1 month ago</span>
           <p>Where is this school located? </p>
           <div class="iconsContainer">
              <div class="likesContainer">
               <v-icon >mdi-thumb-up</v-icon>
               <span class="grey--text caption ml-1">12</span>
              </div>

              <v-btn small outlined class="ml-5 ">REPLY</v-btn>


           </div>
            <v-divider class="mt-2"></v-divider>
         </div>
         
        </div>
           </div>
            <v-divider class="mt-2"></v-divider>
         </div>
        </div>

        <div class="postContainer">
          <div ><v-avatar color="indigo" class="white--text">C</v-avatar></div>
         <div class="items">
           <span class="font-weight-medium">Carolina</span> 
           <span class="caption grey--text">1 month ago</span>
           <p>Where is this school located? </p>
           <div class="iconsContainer">
              <div class="likesContainer">
               <v-icon >mdi-thumb-up</v-icon>
               <span class="grey--text caption ml-1">12</span>
              </div>

              <v-btn small outlined class="ml-5 ">REPLY</v-btn>


           </div>
            <v-divider class="mt-2"></v-divider>
         </div>
         
        </div>



         
       </div>
       
    </v-card>

  </div>
</template>


<script>
  
  export default {
    props: ['school'],
    data() {
      return  {
        startReply: null,
        viewReplies: null,
        showPaClubInfo: false,
          items: [
        {
          avatar: 'https://cdn.vuetifyjs.com/images/lists/1.jpg',
          name: 'A',
          title: 'Does this program accept AP credits?',
          date: 'June 15, 2020',
          subtitle: "",
        },
        { divider: true, inset: true },
        {
          avatar: 'https://cdn.vuetifyjs.com/images/lists/2.jpg',
          name: 'M',
          title: 'Anybody know the interview style for this program?',
          date: '1 month ago',
          subtitle: "",
        },
        { divider: true, inset: true },
        {
          avatar: 'https://cdn.vuetifyjs.com/images/lists/3.jpg',
          name: 'G',
          title: 'Looking for roomate for the 2020-2021 class. Anyone interested please reply',
          date: '1 month ago',
          subtitle: "",
        },
        { divider: true, inset: true },
        {
          avatar: 'https://cdn.vuetifyjs.com/images/lists/4.jpg',
          name: 'B',
          title: 'Britany',
          date: '5 month ago',
          subtitle: "<span class='text--primary'>Trevor Hansen</span> &mdash; Have any ideas about what we should get Heidi for her birthday?",
        },
        { divider: true, inset: true },
        {
          avatar: 'https://cdn.vuetifyjs.com/images/lists/5.jpg',
          title: 'Jacob',
          name: 'J',
          date: '2 years ago',
          subtitle: "<span class='text--primary'>Britta Holt</span> &mdash; We should eat this: Grate, Squash, Corn, and tomatillo Tacos.",
        },
      ],
      }
    },
    methods: {
      replyToComment () {
        
      }
    }
  }
</script>

<style scoped>
.viewRepliesContainer{
  margin-top: 10px;
}
#container {
  width:100%;
  display: flex ;
  flex-direction: column;
  align-content:center;
  
  
}

.postContainer {
  padding:10px;
  display: flex ;
  flex-direction: row;

}

.iconsContainer {
  display: flex;

}

.likesContainer {
  display: flex;
  align-items: center;
}

.items {
  margin-left:10px;
  background-color: white;
  width:100%;
}

 .card {
    border-radius: 10px;
  }
     #buttonShadow {
  box-shadow: 0 10px 30px -10px rgba(0,0,0,.19);
}

.link {
  text-decoration: none;
}
img {
  width:30px;
  height:30px;
}

.linkLogo {
  width:33px;
  height:33px;
  margin-left:10px;
  margin-right: 10px;
  border-radius:5px;
}

.tweetLogo {
  width:37px;
  height:37px;
  margin-left:10px;
  margin-right: 10px;
  border-radius:10px;
}
.blueHeading {
  color:#2196F3;
}

.background {
  background-color: rgb(255, 255, 255);
}

.coupon-box {
  position: relative;
  
}

.coupon-box__button {
  position: absolute;
  top: 50%;
  margin-top: -10px;
  right: 10px;
  z-index: 2;
}

.promoCodeInput {
  font-size: 16px;
  width:150%;
  padding:10px;
  border: 1px solid rgb(196, 196, 196);
  border-radius: 10px;
  margin-top: 10px;
  outline: none;
  color: grey;
  
}
 
</style>



// WEBPACK FOOTER //
// src/components/Schools/SchoolDetail/PrePaClub.vue